module.exports = __webpack_public_path__ + "img/hr-puberty-decal-11.22b92a0c.png";